module.exports = __webpack_public_path__ + "static/media/transiluminator-switch-off.9a97e035.svg";